import React from "react";
import { Box, Grid, Typography, TextField, MenuItem } from "@mui/material";
import { alpha } from "@mui/system";
import { CalendarToday } from "@mui/icons-material";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";

export default function PeriodoSection({
	theme,
	isAgendamentoEnabled,
	dataInicial,
	setDataInicial,
	dataFinal,
	setDataFinal,
	periodoTipo,
	setPeriodoTipo,
	diasPersonalizado,
	setDiasPersonalizado,
}) {
	return (
		<Box
			sx={{
				p: 2,
				bgcolor: theme.palette.background.paper,
				borderRadius: "12px",
				width: "100%",
				mb: 1,
			}}
		>
			{/* Cabeçalho */}
			<Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
				<Box
					sx={{
						backgroundColor: alpha(theme.palette.primary.main, 0.2),
						borderRadius: "10px",
						width: "35px",
						height: "35px",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
				>
					<CalendarToday
						fontSize="small"
						sx={{
							color:
								theme.palette.mode === "dark"
									? theme.palette.primary.light
									: theme.palette.primary.dark,
						}}
					/>
				</Box>
				<Typography variant="h6" sx={{ fontWeight: "bold", fontSize: "16px" }}>
					Período dos Dados
				</Typography>
			</Box>

			{/* Modo sem agendamento: seletores de data/hora */}
			{!isAgendamentoEnabled ? (
				<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
					<Grid container spacing={2} sx={{ mt: 1 }}>
						<Grid item xs={12} sm={6}>
							<Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
								<Typography
									variant="body2"
									sx={{ color: "text.secondary", fontWeight: 600 }}
								>
									Início
								</Typography>
								<DateTimePicker
									format="DD/MM/YY HH:mm"
									ampm={false}
									value={dataInicial ? dayjs(dataInicial) : null}
									onChange={(v) => setDataInicial(v?.toDate() ?? null)}
									 minDate={dayjs().subtract(3, "month")}
									slotProps={{
										textField: { size: "small", fullWidth: true },
									}}
								/>
							</Box>
						</Grid>
						<Grid item xs={12} sm={6}>
							<Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
								<Typography
									variant="body2"
									sx={{ color: "text.secondary", fontWeight: 600 }}
								>
									Fim
								</Typography>
								<DateTimePicker
									format="DD/MM/YY HH:mm"
									ampm={false}
									value={dataFinal ? dayjs(dataFinal) : null}
									onChange={(v) => setDataFinal(v?.toDate() ?? null)}
									minDate={dayjs().subtract(3, "month")}
									slotProps={{
										textField: { size: "small", fullWidth: true },
									}}
								/>
							</Box>
						</Grid>
					</Grid>
				</LocalizationProvider>
			) : (
				// Modo com agendamento: tipo de período
				<Grid container spacing={2} sx={{ mt: 1 }}>
					<Grid item xs={12} sm={6}>
						<Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
							<Typography
								variant="body2"
								sx={{ color: "text.secondary", fontWeight: 600 }}
							>
								Tipo de Período
							</Typography>
							<TextField
								select
								size="small"
								fullWidth
								value={periodoTipo}
								onChange={(e) => setPeriodoTipo(e.target.value)}
							>
								{["Semanal", "Quinzenal", "Mensal", "Personalizado"].map((v) => (
									<MenuItem key={v} value={v}>
										{v}
									</MenuItem>
								))}
							</TextField>
						</Box>
					</Grid>

					{periodoTipo === "Personalizado" && (
						<Grid item xs={12} sm={6}>
							<Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
								<Typography
									variant="body2"
									sx={{ color: "text.secondary", fontWeight: 600 }}
								>
									Quantidade de Dias
								</Typography>
								<TextField
									size="small"
									fullWidth
									placeholder="Ex: 10"
									value={diasPersonalizado}
									onChange={(e) => {
										if (/^\d*$/.test(e.target.value))
											setDiasPersonalizado(e.target.value);
									}}
								/>
							</Box>
						</Grid>
					)}
				</Grid>
			)}
		</Box>
	);
}
